import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import { StickyTopRowStack, StickyTopRowStackSpaceBetween, StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import StoreFilter from "../../components/commonComponents/Filters/StoreFilter";
import LabelsFilter from "./Filters/LabelsFilter";
import DateRangeFilter from "../../components/commonComponents/Filters/DateRangeFilter";
import { filterRangeValue } from "../../api_calls/TableauVisuals";
import SingleSelectStoreFilter from "../../components/commonComponents/Filters/SingleSelectStoreFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  dbFormatDate,
  formatToStandardDate,
  resetBrandReportView,
  standardFormatToday,
  storeListOptionsForFilter,
  findStoreIds,
  findEmbeddableId,
} from "../../api_calls/utils";
import DateRangeInputFields from "../../components/commonComponents/Filters/DateRangeInputFields";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";
import { resolveEmbeddableNumberRoot } from "../../api_calls/retailerSelection";
import platformConfig from "../../platformConfig";

const TrolleyUsage = () => {
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const numberRoot = resolveEmbeddableNumberRoot(userInfo.root_company_id);
  const dispatchAction = useDispatch();
  const { date_range_start_date, date_range_end_date } = userStateDate;

  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = date_range_start_date
      ? new Date(date_range_start_date)
      : new Date("2023-02-07");

    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end,
    };
  }, [date_range_start_date, date_range_end_date]);

  const dashboardVariables = () => {
    let trolleyUsageVariables = {};

    if (typeof userStateDate.embedded_trolley_usage_stores !== "undefined" && typeof userStateDate.embedded_trolley_usage_stores.store_ids !== "undefined" && userStateDate.embedded_trolley_usage_stores.store_ids.length !== 0) {
      trolleyUsageVariables = {
        ...trolleyUsageVariables,
        Stores: userStateDate.embedded_trolley_usage_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_trolley_usage_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_trolley_usage_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      trolleyUsageVariables = {
        ...trolleyUsageVariables,
        Date: {
          from: userStateDate?.embedded_trolley_usage_date.from,
          to: endDate
        },
      }
    }

    return trolleyUsageVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    resetBrandReportView();
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);
  return (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      <StickyTopRowStackSpaceBetween
        spacing={2}
        direction={"row"}
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", ml: "auto" }}>
          {/* ----------- labels filter ---------- */}
          {/* <Box sx={{ width: 90 }}>
          <LabelsFilter reduxKeywordToSaveValue={"embedded_trolley_usage_labels"} />
        </Box> */}
          {/* ------- stores filter ----------- */}
          <Box sx={{ width: 250 }}>
            <SingleSelectStoreFilter
              usedFor={"retail-analytics-journey"}
              reduxKeywordToSaveValue={"embedded_trolley_usage_stores"}
            />
          </Box>
          {/* ------------ day timestamp filter ------------ */}
          {typeof userStateDate.date_range_start_date !== "undefined" && (
            <Box>
              <DateRangeInputFields
                minSelectableDate={minSelectableDate}
                maxSelectableDate={maxSelectableDate}
                reduxKeywordToSaveValue={"embedded_trolley_usage_date"}
              />
            </Box>
          )}
        </Box>

      </StickyTopRowStackSpaceBetween>
      <Box height={1} />
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" &&
          typeof userStateDate.store_dates !== "undefined" &&
          typeof userStateDate.embedded_trolley_usage_stores !== "undefined" && (
          <Dashboard
            key={numberRoot}
            embedDashboardId={findEmbeddableId("retail_analytics", "trolley_usage")}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": numberRoot,
            }} />
        )}
      </Grid>
    </StyledMainBox>
  );
};
// remove array if all user types are allowed. if only some are allowed, add them like below
export default AccessControl(TrolleyUsage, ["analytics_can_view"], platformConfig.retailAnalyticsAvailableFor, ["retail_analytics_section", "trolley_usage"]);
